import React from "react";
import Header from "../../appLayout/header";
import "./index.scss";
import { Button, Col, Row } from "react-bootstrap";
import heroImage from "../../../assets/images/slideApropos.png";
import { ButtonApp } from "../../ButtonApp";
import { useNavigate } from "react-router-dom";
export const SlideApropos = () => {
  const navigate = useNavigate();
  const handleNavigation = () => {
    navigate("/contact#contact-section");
  };

  return (
    <div className="slide-apropos">
      <div className="header-apropos pt-5">
        <Header />
      </div>
      <div className="slide-apropos-container  ">
        <Row className="align-items-center justify-content-center gx-0  h-100">
          <Col md={6}>
            <h1 className="slide-title ">Qui Sommes-Nous ?</h1>
            <div className="descri-slide-mobile">
              <p className="text-slide mt-3 mb-3">
                Consultek est né d’une vision simple mais ambitieuse :
                révolutionner l’accompagnement des entreprises en alliant
                l’expertise du conseil traditionnel à l’innovation
                technologique. Notre cabinet réunit une équipe passionnée
                d’experts pluridisciplinaires, animés par une même obsession :
                votre réussite.
              </p>
              <ButtonApp
                title={"Contactez-nous"}
                handlClick={handleNavigation}
              />
            </div>
          </Col>
          <Col md={6}>
            <img
              src={heroImage}
              alt="Consultante digitale"
              className="img-fluid"
            />
          </Col>
        </Row>
      </div>
    </div>
  );
};
